import axios from '@/libs/api.request'
import _axios from 'axios'
import Qs from 'qs'
// import config from '@/config'
export const unSelect = (params) => {
  return axios.request({
    url: 'secordPublicSelectFalse.do',
    data: Qs.stringify(params),
    method: 'post',
  })
}
export const select = (params) => {
  return axios.request({
    url: 'secordPublic.do',
    method: 'get',
    params: params,
  })
}

export const selectByPage = (params) => {
  return axios.request({
    url: 'selectByPage.do',
    method: 'get',
    params: params,
  })
}
export const handlepicupload = (params) => {
//   let _config = {
//     headers: {'Content-Type': 'multipart/form-data'}
//  }
  return _axios.request({
    method:'post',
    url: 'http://server.1000classes.com/bmcserver/FileResourceUpload?ftype=8',
    data: params,
    // headers: {'Content-Type': 'multipart/form-data'}
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    transformRequest: [function (data) {
      return data
    }]
  })
}